module.exports = __webpack_public_path__ + "media/images/sp/icon-plus-a585d8d5ec8ec571d21b2f2b5851f6e7.png";